<template>
  <component :is="component" v-if="component" :termsData="termsData"/>
</template>

<script>
export default {
  name: "TermsWriteLink",
  mixins: [],
  components: {},
  provide() {
    return {}
  },
  props: {
    writeLayout: {},
    termsData: {default: () => {return {}}},
  },
  data() {
    return {
      component: null,
    }
  },
  created() {
  },
  mounted() {
    this.writeLoader()
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
    loader() {
      if (!this.writeLayout) {
        return null
      }
      return () => import(`@/template/terms/write/${this.writeLayout}`)
    },
  },
  methods: {
    writeLoader() {
      this.loader()
          .then(() => {
            this.component = () => this.loader()
          })
          .catch(() => {
            this.component = () => import('@/template/terms/write/TermsWriteDefaultLayout')
          })
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>